// Gère le comportement dynamique du formulaire de contact lorsque la raison
// "Exercer mon droit de rétractation" est sélectionnée : texte du bouton,
// message de succès, et envoi d'un email de confirmation client.
//
// L'option est identifiée par sa POSITION (data-withdrawal-index), pas par son
// texte : le texte est traduit par Shopify selon la langue du client, la
// position ne change jamais.
(function () {
    var STORAGE_KEY = 'tfContactReason';

    function findWithdrawalSelect(form) {
        var selects = form.querySelectorAll('select[data-withdrawal-index]');
        for (var i = 0; i < selects.length; i++) {
            var index = parseInt(selects[i].dataset.withdrawalIndex, 10);
            if (index > 0) return selects[i];
        }
        return null;
    }

    function isWithdrawalSelected(select) {
        var index = parseInt(select.dataset.withdrawalIndex, 10);
        return index > 0 && select.selectedIndex === index;
    }

    function collectContactFields(form) {
        var formData = new FormData(form);
        var fields = {};
        formData.forEach(function (value, key) {
            var match = key.match(/^contact\[(.+)\]$/);
            if (match) fields[match[1]] = value;
        });
        return fields;
    }

    function sendConfirmationEmail(form) {
        var fields = collectContactFields(form);
        var localeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch('/apps/amalgamous/retraction/request', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                locale: document.documentElement.lang,
                localeRoot: localeRoot,
                fields: fields,
            }),
            keepalive: true,
        }).catch(function () {});
    }

    function initForm(form) {
        var select = findWithdrawalSelect(form);
        if (!select) return;

        var submitBtn = form.querySelector('button[type="submit"]');
        var defaultBtnText = submitBtn ? (submitBtn.dataset.btnTextDefault || submitBtn.textContent.trim()) : null;
        var withdrawalBtnText = submitBtn ? (submitBtn.dataset.btnTextWithdrawal || defaultBtnText) : null;

        var textarea = form.querySelector('textarea[data-label-withdrawal]');
        var defaultTextareaLabel = textarea ? (textarea.dataset.labelDefault || textarea.placeholder) : null;
        var withdrawalTextareaLabel = textarea ? textarea.dataset.labelWithdrawal : null;

        function updateFields() {
            var withdrawal = isWithdrawalSelected(select);

            if (submitBtn) {
                submitBtn.textContent = withdrawal ? withdrawalBtnText : defaultBtnText;
            }

            if (textarea && withdrawalTextareaLabel) {
                var label = withdrawal ? withdrawalTextareaLabel : defaultTextareaLabel;
                textarea.placeholder = label;
                textarea.setAttribute('aria-label', label);
            }
        }

        select.addEventListener('change', updateFields);
        updateFields();

        form.addEventListener('submit', function () {
            var withdrawal = isWithdrawalSelected(select);
            try {
                sessionStorage.setItem(STORAGE_KEY, withdrawal ? 'withdrawal' : 'other');
            } catch (e) {}

            if (withdrawal) {
                sendConfirmationEmail(form);
            }
        });
    }

    function initSuccessMessage(successEl) {
        var form = successEl.closest('form');
        if (!form) return;

        var reason;
        try {
            reason = sessionStorage.getItem(STORAGE_KEY);
            sessionStorage.removeItem(STORAGE_KEY);
        } catch (e) {
            reason = null;
        }

        if (reason !== 'withdrawal') return;

        var template = form.querySelector('[data-success-msg-withdrawal]');
        if (template) {
            successEl.innerHTML = template.innerHTML;
        }
    }

    document.querySelectorAll('form.contact-form').forEach(initForm);
    document.querySelectorAll('.form-success').forEach(initSuccessMessage);
})();
